var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormGroup',{staticClass:"files-input",attrs:{"title":_vm.label,"shortTitle":_vm.shortTitle,"required":_vm.required,"help":_vm.help}},[_c('Dropzone',{ref:"dropzone",attrs:{"options":_vm.dropzoneOptions,"v":_vm.v},on:{"remove":_vm.handleRemove,"add":_vm.handleInput}}),(_vm.v && _vm.v.$error)?_c('FormError',{attrs:{"v":_vm.v}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }